import { render, staticRenderFns } from "./ObjectAddon.vue?vue&type=template&id=79c0930d&scoped=true&"
import script from "./ObjectAddon.vue?vue&type=script&lang=js&"
export * from "./ObjectAddon.vue?vue&type=script&lang=js&"
import style0 from "./ObjectAddon.vue?vue&type=style&index=0&id=79c0930d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c0930d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
